'use client';
import { Tabs, TabsProps } from 'antd';
import CreditMemoList from './CreditMemoList';
import InvoiceList from './InvoiceList';
import PaymentList2 from './PaymentList';

export default function ReceivablesCard() {
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Open Invoices',
      children: <InvoiceList />,
    },
    {
      key: '2',
      label: 'Payments',
      children: <PaymentList2 />,
    },
    {
      key: '3',
      label: 'Credit Notes',
      children: <CreditMemoList />,
    },
    {
      key: '4',
      label: 'Closed Invoices',
      children: <InvoiceList closed />,
    },
  ];

  return (
    <main>
      <Tabs
        tabBarStyle={{
          paddingLeft: '1rem',
          backgroundColor: 'white',
        }}
        defaultActiveKey="1"
        items={items}
      />
    </main>
  );
}
